/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Modal, Backdrop, Fade, CircularProgress, Box } from '@mui/material';

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { gsap } from "gsap";
import person from "../../img/person.svg";
import trophy from "../../img/TrophyCup.svg";
import menuTrophy from "../../img/menuTrophy.svg";
import YETI_PROFILE from "../../constants/yetiProfile";
import GameboardName from "./GameboardName";
import { niceAxisMax } from "./rulerScale";
import { useTheme } from "@mui/material/styles";
import CloseIcon from '@mui/icons-material/Close';
import SoftProfile from "../ProfilePictures/SoftProfile";
import SoftBox from "../SoftBox";
import SoftButton from "../SoftButton";
import SoftInput from "../SoftInput";
import { CountUp } from "countup.js";
import useMediaQuery from "@mui/material/useMediaQuery";
import SoftTypography from "../SoftTypography";
import { borderRadius, display, height, margin, textAlign, width } from "@mui/system";
import UploadIcon from "@mui/icons-material/Upload";
import ImageCropper from "../../pages/Feed/ImageCropper";
import Avatar from "@mui/material/Avatar";
import { PUT_WORKSPACE_IMAGE, SUBMIT_AWARD_PRICE, GET_AWARD } from "../../api/group";
import { GET_IMAGE } from "../../helpers/images";
import { useForm } from "react-hook-form";
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
gsap.core.globals("ScrollTrigger", ScrollTrigger);
import { UseIsAdmin } from "../../hooks/auth";
import { UseSelectedWorkspace } from "../../hooks/company";
import { GET_IMAGE_URL } from "../../helpers/images";
import { position } from "stylis";
import { ReactComponent as SvgGameboardTitleBg } from "../../img/GameboardTitleBgUpdated.svg";
import zIndex from "@mui/material/styles/zIndex";
import FacetedMountain, { TRAIL_PATH } from "./FacetedMountain";
import PeakTrophyOverlay from "../Trophy3D/PeakTrophyOverlay";

// The visible/motion trail is now Victor's winding Vector 24 (shared TRAIL_PATH),
// which is NOT vertically linear (it has summit switchbacks). To keep each
// climber's marker aligned with the numeric ruler on the right, we drive the
// marker to the point on the trail whose SCREEN HEIGHT matches the ruler value
// for that score — not a raw % of path length. This makes the marker ride the
// pretty trail while its pink line still reads the correct number on the ruler.
// Ruler is remapped (via a transform on #menu) to span the mountain: max tick at
// the peak (~y174) and 0 tick at the trail base (~y592). These MUST match that
// remapped range so each marker lands at the ruler value it reads.
const RULER_Y_TOP = 174; // y of the maxPoint tick (peak)
const RULER_Y_BOT = 592; // y of the 0 tick (trail base)
const lengthFracForScore = (lineId, pts, maxPoint) => {
  const frac = Math.min((pts || 0) / (maxPoint || 1), 0.999);
  const path =
    typeof document !== "undefined" && document.querySelector(`#${lineId}`);
  if (!path || !path.getTotalLength) return Math.min(frac, 0.99);
  const targetY = RULER_Y_BOT - frac * (RULER_Y_BOT - RULER_Y_TOP);
  const total = path.getTotalLength();
  const steps = 260;
  for (let i = 0; i <= steps; i += 1) {
    const l = (i / steps) * total;
    // climbing = decreasing y; stop at the first point that reaches the height
    if (path.getPointAtLength(l).y <= targetY) {
      if (i === 0) return 0;
      // Refine between the bracketing samples: the coarse walk overshoots by
      // up to one step (~7px of height ≈ ~95 ruler points on this board — the
      // "4,230 reads as 4,252" QA bug). Binary-search the exact crossing so
      // the marker's connector line meets the ruler AT the score.
      let lo = ((i - 1) / steps) * total;
      let hi = l;
      for (let b = 0; b < 24; b += 1) {
        const mid = (lo + hi) / 2;
        if (path.getPointAtLength(mid).y <= targetY) hi = mid;
        else lo = mid;
      }
      return Math.min(hi / total, 0.99);
    }
  }
  return 0.99;
};

const movePerson = (name, pts, maxPoint) => {
  const tempElem = {
    pts: 0,
  };

  // stopping point on the trail whose height matches the ruler value for `pts`
  const endPoint = lengthFracForScore(`${name}-line`, pts, maxPoint);


  if (endPoint === 1) {
    return gsap
      .timeline()
      .to(`#${name}`, {
        duration: 4,
        ease: "sine.out",
        motionPath: {
          path: `#${name}-line`,
          align: `#${name}-line`,
          alignOrigin: [0.5, 1],
          start: 0,
          end: endPoint,
        },
      })
      // The standing marker (#end-g-…) is deliberately NOT animated here. GSAP's
      // align mode centres the group's bounding box on the trail, and this group
      // hides an invisible r=1109 circle plus a full-width connector line — so
      // "centre" lands nowhere near the dot. The robust placement effect below
      // owns the markers; when this legacy climb also moved them, whichever
      // finished last won, which is why markers drifted on re-renders/resizes.
      .to(
        `#${name}-circle`,
        {
          duration: 4,
          ease: "sine.out",
          strokeDashoffset: 337 - 337 * endPoint,
        },
        "<",
      )
      .to(
        tempElem,
        {
          duration: 4,
          pts,
        },
        "<",
      )
      .from(`#end-circle-${name}`, {
        duration: 1,
        transformOrigin: "50% 50%",
        scale: 0,
        ease: "sine.inOut",
      })
      .from(
        `#end-line-${name}`,
        {
          duration: 1,
          transformOrigin: "0% 50%",
          scaleX: 0,
          ease: "sine.inOut",
        },
        "<",
      )
      .to(`#${name}`, { duration: 1, y: "+=-5", ease: "sine.inOut" }, "<")
      .to(`#${name}`, { duration: 1, y: "+=5", ease: "sine.inOut" }, ">")
      .fromTo(
        `#trophy`,
        { y: 0 },
        { duration: 1, y: "+=5", ease: "sine.inOut" },
        "<",
      );
  } else {
    return gsap
      .timeline()
      .to(`#${name}`, {
        duration: 4,
        ease: "sine.out",
        motionPath: {
          path: `#${name}-line`,
          align: `#${name}-line`,
          alignOrigin: [0.5, 1],
          start: 0,
          end: endPoint + 0.01,
        },
      })
      // Marker group intentionally untouched — see the note in the other branch;
      // the placement effect below is the markers' single owner.
      .to(
        `#${name}-circle`,
        {
          duration: 4,
          ease: "sine.out",
          strokeDashoffset: 337 - 337 * endPoint,
        },
        "<",
      )
      .to(
        tempElem,
        {
          duration: 4,
          pts,
        },
        "<",
      )
      .from(`#end-circle-${name}`, {
        duration: 1,
        transformOrigin: "50% 50%",
        scale: 0,
        ease: "sine.inOut",
      })
      .from(
        `#end-line-${name}`,
        {
          duration: 1,
          transformOrigin: "0% 50%",
          scaleX: 0,
          ease: "sine.inOut",
        },
        "<",
      );
  }
};

// animation

gsap.set("#person1-circle, #person2-circle", {
  strokeDasharray: 337,
  strokeDashoffset: 337,
});
gsap.fromTo(
  "#trophy",
  { transformOrigin: "0% 100%", scaleX: 1, skewY: 1 },
  {
    duration: 1,
    transformOrigin: "0% 100%",
    yoyo: true,
    ease: "sine.inOut",
  },
);

const startTL = gsap
  .timeline({ paused: true })
  .from("#mount1", { duration: 1, y: 500, opacity: 0 })
  .from("#mount2", { duration: 1, y: 500, opacity: 0 }, "<+0.5")
  .from("#mount3", { duration: 1, y: 500, opacity: 0 }, "<+0.5")
  .from("#menu", { duration: 1, opacity: 0 }, "<")
  .from("#avatarSvg", { duration: 1, opacity: 0 }, "<+0.5");

gsap.set("#gameMyBizSVG", { opacity: 1 });

// Component
const KingOfTheMountain = ({
  cardTitle,
  maxPoint,
  yetiScore,
  playerScore,
  playerName,
  playerLogo,
  darkMode,
  noScroll,
  dashboard,
  // Optional: when supplied, renders the given React node inside a foreignObject
  // at the SAME SVG coords as the static trophy (TV view uses this to drop in
  // a 3D rotating trophy without forking the component).
  tvTrophyOverlay,
  // When true, the rotating 3D trophy is rendered as an HTML overlay OUTSIDE the
  // SVG (WebGL can't be measured inside a scaled foreignObject). Used by the
  // dashboard; TV keeps tvTrophyOverlay.
  peakTrophy,
}) => {
  // Ruler top rounded up so all 9 ticks read as round numbers (0, 1000, 2000 …)
  // instead of eighths of a raw score. Scores are never rounded — the markers are
  // placed against this same value, so each one still sits at its exact score.
  const axisMax = niceAxisMax(maxPoint);

  const boardRef = useRef();
  const svgRef = useRef();
  const [animation, setAnimation] = useState(null);
  const theme = useTheme();
  const playerPtsRef = useRef();
  const yetiPtsRef = useRef();
  const [imageURL, setImageURL] = useState(null);
  const fileRef = useRef();
  const formRef = useRef(null);

  useEffect(() => {
    // Cleanup
    return () => {
      URL.revokeObjectURL(imageURL);
    }
  }, [imageURL]);

  const setSelectedFile = async (e) => {
    const pictureBlob = URL.createObjectURL(e.target.files[0]);

    setImageURL(pictureBlob);
    fileSelectedCallback?.(e.target.files[0]);
  }

  const clearFile = (e) => {
    e.preventDefault();

    URL.revokeObjectURL(imageURL);
    setImageURL(null);
    fileRef.current.value = null;

    fileSelectedCallback?.(null, true);
  }

  useEffect(() => {
    if (maxPoint) {
      const rightNums = document.querySelectorAll("#right-nums text");
      const canRightNums = rightNums ? rightNums.href : "";
      if (rightNums.length > 0 && canRightNums) {
        for (let i = 0; i < 9; i++) {
          if (i === 0) {
            rightNums[i].innerHTML = "+ " + (axisMax - (axisMax / 8) * i);
          } else {
            rightNums[i].innerHTML = axisMax - (axisMax / 8) * i;
          }
        }
      }

      if (animation) {
        animation.kill();
      }

      // Setup count up sequence for Player and Yeti Points
      const playerCountup = new CountUp(
        playerPtsRef?.current,
        Number.isNaN(playerScore) || !Number.isFinite(playerScore)
          ? 0
          : playerScore,
        { duration: 2.5, useEasing: true, separator: "," },
      );
      const yetiCountup = new CountUp(yetiPtsRef?.current, yetiScore, {
        duration: 2.5,
        useEasing: true,
        separator: ",",
      });
      playerCountup.start();
      yetiCountup.start();

      // Set scroll trigger only if board is not shown in full screen
      const boardAnim = gsap
        .timeline({
          ...(noScroll
            ? {}
            : {
                scrollTrigger: {
                  trigger: boardRef.current,
                  start: "top center",
                  once: true,
                },
              }),
        })
        .to(startTL, { duration: 3, progress: 1, ease: "none" })
        .add(movePerson("person1", playerScore, axisMax).restart())
        .add(movePerson("person2", yetiScore, axisMax).restart(), "<")
        .from("#persons", { duration: 1, opacity: 0 }, "<");

      setAnimation(boardAnim);

      return () => {
        if (boardAnim) {
          boardAnim.kill();
        }
      };
    }
  }, [maxPoint, yetiScore, playerScore]);

  // Robust marker climb — owns ONLY the two standing markers. The legacy
  // nested-timeline climb above is unreliable inside the customizable grid
  // (re-renders kill it mid-flight, leaving the markers stuck at scale 0). Here
  // we take over the markers: kill any legacy tweens on them, then climb each
  // to the point on the trail whose height matches its ruler value, revealing
  // the dot + connector line. Runs after paint (rAF) and is idempotent.
  useEffect(() => {
    if (!maxPoint) return undefined;
    // ox/oy = each marker group's authored dot centre; we translate the group so
    // that point rides the trail (deterministic — avoids GSAP motionPath `align`
    // mis-offsetting against the group's oversized bbox). Scores load
    // asynchronously (0 → … → final), so we tween the marker from its CURRENT
    // spot to the latest target — it converges on the final score. Because the
    // dashboard grid re-renders a lot, a single rAF can get cancelled before it
    // fires; we also re-place on delayed timeouts so the marker always lands on
    // the final settled score for THIS effect run (this run's closure holds the
    // latest scores; cleanup clears these when scores change again).
    const place = () => {
      [
        ["person2", yetiScore, 474, 541],
        ["person1", playerScore, 423, 523],
      ].forEach(([name, pts, ox, oy]) => {
        const line = document.querySelector(`#${name}-line`);
        const grp = document.querySelector(`#end-g-${name}`);
        if (!line || !grp || !line.getTotalLength) return;
        const total = line.getTotalLength();
        const end = lengthFracForScore(`${name}-line`, pts, axisMax);
        const p = line.getPointAtLength(end * total);
        gsap.set("#persons", { opacity: 1 });
        gsap.set(`#end-circle-${name}`, { scale: 1, transformOrigin: "50% 50%" });
        gsap.set(`#end-line-${name}`, { scaleX: 1, transformOrigin: "0% 50%" });
        gsap.to(grp, {
          x: p.x - ox,
          y: p.y - oy,
          duration: 1.1,
          ease: "sine.out",
          overwrite: "auto",
        });
      });
    };
    const raf = requestAnimationFrame(place);
    const t1 = setTimeout(place, 600);
    const t2 = setTimeout(place, 1800);
    const t3 = setTimeout(place, 3500);
    // Re-settle after any size change (viewport resize, grid cell resize) —
    // getTotalLength/getPointAtLength read the live path, so replacing after a
    // reflow keeps the marker on the ruler value at every size.
    let resizeT;
    const onResize = () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(place, 200);
    };
    window.addEventListener("resize", onResize);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(resizeT);
      window.removeEventListener("resize", onResize);
    };
  }, [maxPoint, yetiScore, playerScore]);

  const {
    primary: { main: primaryColor, light: brighterPrimaryColor },
    secondary: { main: darkerPrimaryColor },
  } = theme.palette;

  const isAdmin = UseIsAdmin();

  const smBp = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const lgBp = useMediaQuery((theme) => theme.breakpoints.up("xxl"));

  const [openModal, setOpenModal] = useState(false);
  const [openPriceModal, setOpenPriceModal] = useState(false);

  const handlePriceClick = () => {
    setOpenPriceModal(true);
  };

  const handleClosePriceModal = () => {
    setOpenPriceModal(false);
  };

  const handleImageClick = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Light frosted-glass modal paper (shared by both KotM modals below).
  // TRUE center (was top: 35% — sat visibly high), compact width: a prize
  // form doesn't need 600px. Standard glass recipe (72% white + blur 18).
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'rgba(255,255,255,0.72)',
    borderRadius: '8px',
    boxShadow: '0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)',
    padding: '1.25rem 1.375rem',
    // Approved prototype: compact ~400px paper — the modal holds a prize line
    // and a photo strip, nothing that justifies a tall, wide sheet.
    maxWidth: { mini: "92%", xs: "92%", sm: "400px" },
    width: "100%",
    maxHeight: "88vh",
    overflowY: "auto",
    outline: "none", // kill the browser focus ring MUI Modal puts on the paper
    border: "1px solid rgba(255,255,255,0.6)",
    backdropFilter: 'blur(18px) saturate(160%)',
    WebkitBackdropFilter: 'blur(18px) saturate(160%)'
  };

  const { register, handleSubmit, reset, setValue, getValues } = useForm({
    defaultValues: {
      image: "",
      name: "",
    },
  });

  const imageInputRef = useRef();
  const [openDialog, setOpenDialog] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const handleUpload = () => {
    imageInputRef.current.value = null;
    imageInputRef.current.click();
  };

  const handleInputChange = async (e) => {
    if (e.target.files.length === 0) {
      return;
    }

    const imgSrc = e.target.files[0];
    if (imgSrc) {
      setImageSrc(URL.createObjectURL(imgSrc));
      setOpenDialog(true);
    }
  };

  const onSaveCroppedImage = async (croppedImageFile) => {
    if (!croppedImageFile) return;
    const formData = new FormData();
    setIsUploading(true);
    formData.append("image", croppedImageFile);
    PUT_WORKSPACE_IMAGE(formData)
      .then(({ data }) => {
        setImageSrc(data.key);
        setValue("image", data.key);
        setIsUploading(false);
      })
      .catch((err) => {
        console.log("Job image upload error", err.message);
        setIsUploading(false);
      });

    setOpenDialog(false);
    imageInputRef.current.value = null;
  };

  const { _id: groupId } = UseSelectedWorkspace();
  const [workspaceData, setWorkspaceData] = useState(null);

  const fetchData = async () => {
    try {
      const response = await GET_AWARD(groupId);
      setWorkspaceData(response.data);  
    } catch (error) {
      console.error("Error fetching the award data:", error);
    }
  };
  
  useEffect(() => {
    fetchData();
  }, [groupId]);
  
  const submitPrice = async () => {
    const priceValue = getValues("price");
    if (formRef.current) {
      const body = {
        groupId: groupId,
        price: priceValue,
        priceImage: imageSrc,
      };
      await SUBMIT_AWARD_PRICE(body);
      fetchData();
    }
    setOpenModal(false);
    imageInputRef.current.value = null;
    reset();
  };

  useEffect(() => {
    return () => {
      setIsUploading(false);
    };
  }, []);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const screenWidth = window.innerWidth;

  // Whoever is ahead on points sits on top; the two cards swap the instant one
  // overtakes the other.
  const playerLeads = (Number(playerScore) || 0) >= (Number(yetiScore) || 0);

  return (
    <>
      {maxPoint > 0 ? (
        <SoftBox className="w-full relative" sx={{ zIndex: 1, paddingTop: { mini: dashboard ? 0 : "24px", lg: 0 }, paddingLeft: { mini: dashboard ? 0 : "1rem", sm: dashboard ? 0 : "1.5rem", lg: 0 }, paddingRight: { mini: dashboard ? 0 : "1rem", sm: dashboard ? 0 : "1.5rem", lg: 0 } }}>
          <SoftBox
            shadow="md"
            sx={{
              width: "100%",
              height: "100%",
              minHeight: "30vh",
              position: "relative",
              overflow: "hidden",
              borderRadius: "8px",
            }}
            ref={boardRef}
            variant="gradient"
            bgColor={darkMode ? "dark" : "transparent"}
          >
            {/** Header — unified 56px strip with hairline divider, matches Team Performance side */}
            <SoftBox
              sx={{
                height: "56px",
                paddingLeft: { mini: "16px", sm: "20px" },
                paddingRight: { mini: "16px", sm: "20px" },
                borderBottom: "1px solid #EAECF0",
                marginBottom: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              <SoftTypography
                sx={{
                  fontFamily: "DM Sans",
                  fontSize: "16px",
                  fontWeight: 600,
                  letterSpacing: "-0.01em",
                  color: "#0F172A",
                  textFillColor: "#0F172A",
                  lineHeight: 1.2,
                }}
              >
                {cardTitle || "King of the Mountain"}
              </SoftTypography>
              <Box sx={{ display: "none" }}>
                <Box
                  sx={{
                    width: "auto",
                    height: "auto",
                  }}
                >
                  <SvgGameboardTitleBg style={{ width: screenWidth === 1024 ? "80%" : "100%" }} />
                  <Box
                    sx={{
                      color: "primary.contrastText",
                      position: "absolute",
                      top: "25%",
                      left: screenWidth === 1024 ? "10%" : "15%",
                      width: "70%",
                      height: "auto",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <svg width={screenWidth === 1024 ? "20" : "22"} height={screenWidth === 1024 ? "20" : "22"} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.3083 18.0858H6.69167C6.01333 18.0858 5.32583 17.5999 5.09667 16.9674L1.30167 6.34327C0.834166 5.00494 1.17333 4.39077 1.54 4.11577C1.90667 3.84077 2.59417 3.67577 3.74917 4.50077L7.32417 7.05827C7.43417 7.12244 7.535 7.14994 7.60833 7.13161C7.69083 7.10411 7.755 7.03077 7.80083 6.90244L9.41417 2.60327C9.9 1.31994 10.615 1.12744 11 1.12744C11.385 1.12744 12.1 1.31994 12.5858 2.60327L14.1992 6.90244C14.245 7.02161 14.3092 7.10411 14.3917 7.13161C14.4742 7.15911 14.575 7.13161 14.6758 7.04911L18.0308 4.65661C19.2592 3.77661 19.9742 3.95077 20.3683 4.23494C20.7533 4.52827 21.1108 5.17911 20.6067 6.59994L16.9033 16.9674C16.6742 17.5999 15.9867 18.0858 15.3083 18.0858ZM2.45667 5.32577C2.475 5.45411 2.51167 5.63744 2.60333 5.87577L6.39833 16.4999C6.435 16.5916 6.6 16.7108 6.69167 16.7108H15.3083C15.4092 16.7108 15.5742 16.5916 15.6017 16.4999L19.305 6.14161C19.4333 5.79327 19.47 5.55494 19.4792 5.41744C19.3417 5.46327 19.1308 5.56411 18.8283 5.78411L15.4733 8.17661C15.015 8.49744 14.4742 8.59827 13.9883 8.45161C13.5025 8.30494 13.1083 7.91994 12.9067 7.39744L11.2933 3.09827C11.1742 2.77744 11.0642 2.62161 11 2.54827C10.9358 2.62161 10.8258 2.77744 10.7067 3.08911L9.09333 7.38827C8.90083 7.91077 8.50667 8.29577 8.01167 8.44244C7.52583 8.58911 6.97583 8.48827 6.52667 8.16744L2.95167 5.60994C2.74083 5.46327 2.57583 5.37161 2.45667 5.32577Z" fill="#FCFCFD"/>
                      <path d="M16.0417 20.8542H5.95834C5.5825 20.8542 5.27084 20.5426 5.27084 20.1667C5.27084 19.7909 5.5825 19.4792 5.95834 19.4792H16.0417C16.4175 19.4792 16.7292 19.7909 16.7292 20.1667C16.7292 20.5426 16.4175 20.8542 16.0417 20.8542Z" fill="#FCFCFD"/>
                      <path d="M13.2917 13.5208H8.70834C8.3325 13.5208 8.02084 13.2091 8.02084 12.8333C8.02084 12.4574 8.3325 12.1458 8.70834 12.1458H13.2917C13.6675 12.1458 13.9792 12.4574 13.9792 12.8333C13.9792 13.2091 13.6675 13.5208 13.2917 13.5208Z" fill="#FCFCFD"/>
                    </svg>
                  </Box>
                  <Box
                    sx={{
                      color: "primary.contrastText",
                      position: "absolute",
                      top: "25%",
                      left: "20%",
                      width: "70%",
                      height: "auto",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      viewBox="0 0 160 18"
                      overflow="visible"
                    >
                      <text
                        x={screenWidth === 1024 ? "50px" : "80"}
                        y="9"
                        fontFamily="DM Sans"
                        fontSize={screenWidth === 1024 ? "8px" : "14px"}
                        fontWeight="500"
                        fill="white"
                        textAnchor="middle"
                        alignmentBaseline="middle"
                      >
                        King of the Mountain
                      </text>
                    </svg>
                  </Box>
                </Box>
              </Box>
              {!isSmallScreen && (
                <svg width={screenWidth === 1024 ? "20" : "24"} height={screenWidth === 1024 ? "20" : "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" 
                  style={{ 
                    marginTop: '1rem',
                    zIndex: 1000,
                    cursor: "pointer",
                    ...(screenWidth <= 1280 && ({ marginRight: '-1rem' }))
                  }}
                  onClick={isAdmin ? handleImageClick : handlePriceClick}>
                  <path d="M10.125 16.125C9.78333 16.125 9.5 15.8417 9.5 15.5V13.75C9.5 13.4083 9.78333 13.125 10.125 13.125C10.4667 13.125 10.75 13.4083 10.75 13.75V15.5C10.75 15.8417 10.4667 16.125 10.125 16.125Z" fill="#292D32"/>
                  <path d="M14.9164 18.958H5.33307V17.4997C5.33307 16.233 6.35807 15.208 7.62474 15.208H12.6247C13.8914 15.208 14.9164 16.233 14.9164 17.4997V18.958ZM6.58307 17.708H13.6664V17.4997C13.6664 16.9247 13.1997 16.458 12.6247 16.458H7.62474C7.04974 16.458 6.58307 16.9247 6.58307 17.4997V17.708V17.708Z" fill="#292D32"/>
                  <path d="M15.125 18.958H5.125C4.78333 18.958 4.5 18.6747 4.5 18.333C4.5 17.9914 4.78333 17.708 5.125 17.708H15.125C15.4667 17.708 15.75 17.9914 15.75 18.333C15.75 18.6747 15.4667 18.958 15.125 18.958Z" fill="#292D32"/>
                  <path d="M15.3586 10.3668C15.1836 10.3668 15.0086 10.2918 14.8836 10.1502C14.7253 9.96683 14.6836 9.70849 14.7836 9.49183C15.0669 8.84183 15.2086 8.15016 15.2086 7.42516V4.92516C15.2086 4.63349 15.1586 4.35016 15.0586 4.05016C15.0503 4.02516 15.0419 3.99183 15.0336 3.95849C15.0086 3.83349 15.0003 3.70849 15.0003 3.59183C15.0003 3.25016 15.2836 2.96683 15.6253 2.96683H16.1253C17.6169 2.96683 18.8336 4.21683 18.8336 5.75849C18.8336 7.03349 18.3086 8.29183 17.4003 9.20016C17.3836 9.21683 17.3336 9.25849 17.3253 9.26683C16.8336 9.67516 16.2753 10.1335 15.5253 10.3418C15.4669 10.3585 15.4169 10.3668 15.3586 10.3668ZM16.4003 4.24183C16.4419 4.46683 16.4586 4.70016 16.4586 4.92516V7.42516C16.4586 7.76683 16.4336 8.09183 16.3836 8.42516C16.4336 8.38349 16.4753 8.35016 16.5253 8.30849C17.1919 7.64183 17.5836 6.70849 17.5836 5.75849C17.5836 5.00849 17.0753 4.37516 16.4003 4.24183Z" fill="#292D32"/>
                  <path d="M4.65033 10.3333C4.58366 10.3333 4.52533 10.325 4.45866 10.3C3.77533 10.0833 3.13366 9.6833 2.60033 9.14997C1.64199 8.09164 1.16699 6.9333 1.16699 5.7083C1.16699 4.19164 2.35866 2.99997 3.87533 2.99997H4.41699C4.62533 2.99997 4.82533 3.1083 4.94199 3.2833C5.05866 3.4583 5.07533 3.6833 4.99199 3.87497C4.85866 4.17497 4.79199 4.51664 4.79199 4.87497V7.37497C4.79199 8.09164 4.93366 8.79164 5.22533 9.4583C5.32533 9.6833 5.27533 9.94164 5.11699 10.125C4.99199 10.2583 4.82533 10.3333 4.65033 10.3333ZM3.58366 4.27497C2.90866 4.4083 2.41699 4.99164 2.41699 5.7083C2.41699 6.61664 2.78366 7.49164 3.50866 8.29164C3.54199 8.3333 3.58366 8.36664 3.62533 8.39997C3.56699 8.0583 3.54199 7.71664 3.54199 7.37497V4.87497C3.54199 4.67497 3.55866 4.47497 3.58366 4.27497Z" fill="#292D32"/>
                  <path d="M10.0003 13.9587C6.44199 13.9587 3.54199 11.0587 3.54199 7.50033V5.00033C3.54199 2.81699 5.31699 1.04199 7.50033 1.04199H12.5003C14.6837 1.04199 16.4587 2.81699 16.4587 5.00033V7.50033C16.4587 11.0587 13.5587 13.9587 10.0003 13.9587ZM7.50033 2.29199C6.00866 2.29199 4.79199 3.50866 4.79199 5.00033V7.50033C4.79199 10.3753 7.12533 12.7087 10.0003 12.7087C12.8753 12.7087 15.2087 10.3753 15.2087 7.50033V5.00033C15.2087 3.50866 13.992 2.29199 12.5003 2.29199H7.50033Z" fill="#292D32"/>
                </svg>
              )}
              <Modal
                open={openModal}
                onClose={handleCloseModal}
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                  // Match the global Dialog backdrop exactly (the
                  // Players-page modals): soft dim + 3px frost.
                  sx: {
                    backgroundColor: "rgba(15,23,42,0.16)",
                    backdropFilter: "blur(3px)",
                    WebkitBackdropFilter: "blur(3px)",
                  },
                }}
              >
                <Fade in={openModal}>
                  {/* Compact prize editor — approved prototype: title + one-liner,
                      Prize input, single photo strip, Cancel/Save footer. */}
                  <SoftBox sx={style}>
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                    >
                      <SoftBox>
                        <SoftTypography sx={{ fontSize: "16px", fontWeight: 600, color: "#101828" }}>
                          King of the Mountain prize
                        </SoftTypography>
                        <SoftTypography sx={{ fontSize: "12.5px", fontWeight: 400, color: "#667085", mt: "2px" }}>
                          The reward for this month&apos;s winner.
                        </SoftTypography>
                      </SoftBox>
                      <SoftBox
                        component="button"
                        type="button"
                        aria-label="Close"
                        onClick={handleCloseModal}
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          border: 0,
                          cursor: "pointer",
                          background: "#F2F4F7",
                          color: "#667085",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          "& svg": { fontSize: "1rem !important" },
                          "&:hover": { background: "#EAECF0" },
                        }}
                      >
                        <CloseIcon />
                      </SoftBox>
                    </SoftBox>

                    <form ref={formRef}>
                      <SoftBox sx={{ mt: "16px" }}>
                        <SoftTypography sx={{ fontSize: "12px", fontWeight: 600, color: "#344054", mb: "5px" }}>
                          Prize
                        </SoftTypography>
                        <SoftInput
                          {...register("price")}
                          name="price"
                          type="text"
                          placeholder="e.g. $250 bonus"
                          defaultValue={workspaceData?.price || ""}
                          sx={{
                            border: "1px solid #D0D5DD",
                            backgroundColor: "#FFFFFF !important",
                            color: "#1d2939 !important",
                            "& .MuiInputBase-input::placeholder": {
                              color: "#98A2B3 !important",
                              opacity: "1",
                            },
                            "&.Mui-focused": {
                              borderColor: primaryColor,
                              boxShadow: "0 0 0 3px rgba(27,89,142,0.08)",
                            },
                          }}
                        />
                      </SoftBox>

                      <SoftBox sx={{ mt: "14px" }}>
                        <SoftTypography sx={{ fontSize: "12px", fontWeight: 600, color: "#344054", mb: "5px" }}>
                          Prize photo{" "}
                          <SoftBox component="span" sx={{ color: "#98A2B3", fontWeight: 400 }}>
                            (optional, for material gifts)
                          </SoftBox>
                        </SoftTypography>
                        <SoftBox
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                            border: "1px dashed #D0D5DD",
                            background: "#F9FAFB",
                            borderRadius: "8px",
                            padding: "10px 12px",
                          }}
                        >
                          <SoftBox
                            sx={{
                              width: 52,
                              height: 40,
                              borderRadius: "6px",
                              overflow: "hidden",
                              flexShrink: 0,
                              background: "#E4EBF2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {isUploading ? (
                              <CircularProgress size={18} />
                            ) : (
                              (() => {
                                const src = getValues("image")
                                  ? GET_IMAGE(getValues("image"))
                                  : workspaceData?.priceImage
                                  ? GET_IMAGE_URL(workspaceData.priceImage)
                                  : "";
                                return src ? (
                                  <Avatar
                                    variant="rounded"
                                    src={src}
                                    sx={{ width: "100%", height: "100%", borderRadius: 0 }}
                                  />
                                ) : (
                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#98A2B3" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" />
                                  </svg>
                                );
                              })()
                            )}
                          </SoftBox>
                          <SoftTypography sx={{ flex: 1, fontSize: "11.5px", color: "#98A2B3" }}>
                            JPEG, PNG or GIF
                          </SoftTypography>
                          <SoftButton
                            onClick={handleUpload}
                            sx={{
                              height: "32px",
                              minHeight: "32px",
                              padding: "0 12px",
                              textTransform: "none",
                              borderRadius: "8px",
                              border: "1px solid #D0D5DD",
                              boxShadow: "none",
                              background: "#FFFFFF !important",
                              color: "#344054",
                              fontSize: "12.5px",
                              fontWeight: 500,
                              "&:hover": { background: "#F9FAFB !important" },
                            }}
                          >
                            Upload
                          </SoftButton>
                          <input
                            ref={imageInputRef}
                            onInput={handleInputChange}
                            accept="image/*"
                            type="file"
                            hidden
                          />
                          <ImageCropper
                            imgSrc={imageSrc}
                            open={openDialog}
                            setOpen={setOpenDialog}
                            onSaveCroppedImage={onSaveCroppedImage}
                          />
                        </SoftBox>
                      </SoftBox>

                      <SoftBox sx={{ display: "flex", justifyContent: "flex-end", gap: "10px", mt: "18px" }}>
                        <SoftButton
                          onClick={handleCloseModal}
                          sx={{
                            background: "#fff",
                            border: "1px solid #D0D5DD",
                            borderRadius: "8px",
                            color: "#344054",
                            fontSize: "13px",
                            fontWeight: 600,
                            textTransform: "none",
                            padding: "0 16px",
                            height: "38px",
                            minHeight: "38px",
                            boxShadow: "none",
                            "&:hover": { background: "#F9FAFB" },
                          }}
                        >
                          Cancel
                        </SoftButton>
                        <SoftButton
                          onClick={submitPrice}
                          sx={{
                            background: "var(--gmb-primary, #1B598E)",
                            border: 0,
                            borderRadius: "8px",
                            color: "#FFFFFF !important",
                            fontSize: "13px",
                            fontWeight: 600,
                            textTransform: "none",
                            padding: "0 18px",
                            height: "38px",
                            minHeight: "38px",
                            boxShadow: "none",
                            "&:hover": { background: "var(--gmb-primary, #1B598E)", filter: "brightness(0.96)" },
                          }}
                        >
                          Save prize
                        </SoftButton>
                      </SoftBox>
                    </form>
                  </SoftBox>
                </Fade>
              </Modal>
            </SoftBox>
            {/** Mountain svg */}
            <div className="absolute w-full h-full">
              <svg
                version="1.1"
                id="avatarSvg"
                xmlns="http://www.w3.org/2000/svg"
                xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 965 615"
              >
                <rect
                  x="157.28"
                  y="186.99"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="none"
                  width="142.72"
                  height="37.01"
                />
              </svg>
            </div>
            <div className="absolute w-full h-full">
              <svg
                version="1.1"
                id="avatarSvg"
                xmlns="http://www.w3.org/2000/svg"
                xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 965 615"
              >
                <rect
                  x="720.28"
                  y="186.99"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="none"
                  width="142.72"
                  height="37.01"
                />
              </svg>
            </div>
            <Modal
              open={openPriceModal}
              onClose={handleClosePriceModal}
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
                // Match the global Dialog backdrop exactly (the
                // Players-page modals): soft dim + 3px frost.
                sx: {
                  backgroundColor: "rgba(15,23,42,0.16)",
                  backdropFilter: "blur(3px)",
                  WebkitBackdropFilter: "blur(3px)",
                },
              }}
            >
              <Fade in={openPriceModal}>
                <SoftBox sx={style}>
                <SoftBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <SoftTypography sx={{textFillColor: "#0F172A"}} variant="h6" component="h2">
                      King of Mountain Award Prize
                    </SoftTypography>
                    <SoftButton
                      variant="outlined"
                      color="light"
                      onClick={handleClosePriceModal}
                      sx={{
                        "& svg": { fontSize: "1.25rem !important" },
                        borderRadius: "50%",
                        minWidth: "max-content",
                        minHeight: "max-content",
                        padding: "0.25rem",
                      }}
                    >
                      <CloseIcon />
                    </SoftButton>
                  </SoftBox>
                  {workspaceData?.price && (
                    <>
                      <SoftTypography sx={{ mt: 4, mb: 3, textFillColor: "#0F172A", textAlign: 'center', fontSize: '32px' }}>
                        {workspaceData?.price}
                      </SoftTypography>
                      <img 
                        style={{ 
                          marginBottom: '4rem', 
                          margin: '0 auto', 
                          maxWidth: '300px', 
                          width: '100%',
                          height: 'auto'
                        }}
                        src={GET_IMAGE_URL(workspaceData?.priceImage)}
                        alt="Workspace"
                      />
                    </>
                  )}
                </SoftBox>
              </Fade>
            </Modal>
            <svg
              height="100%"
              width="100%"
              version="1.1"
              id="gameMyBizSVG"
              ref={svgRef}
              xmlns="http://www.w3.org/2000/svg"
              xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              /* viewBox pulled back: base art ends at y≈671, so 725 leaves the
                 full base + the 0-point sitting comfortably above the card bottom
                 (was clipped at 615). */
              viewBox="0 0 965 725"
              enableBackground="new 0 0 965 615"
              space="preserve"
              /* none = fill the card box at any size (the original responsive
                 behaviour). The ruler, climbers and trophy all live in this same
                 drawing, so they stretch together and the markers stay on their
                 numbers. This is what let the mountain adapt to any screen. */
              preserveAspectRatio="none"
              style={{position: 'relative', zIndex: '1000'}}
            >
              <g>
                <g id="mount2" />
                <g id="mount1" />
                <g id="mount3">
                  {/* Faceted brand-coloured mountain (Figma node 65:308) — every
                      facet is a shade of the company primary colour, so it
                      recolours per company. Same component + 965x615 canvas as
                      the Company View goal card. */}
                  <FacetedMountain color={primaryColor} />
                  {/* Victor's Vector 24 climbing trail — the standing markers
                      ride this exact route (person1-line / person2-line below). */}
                  <path
                    fill="none"
                    stroke="#FFFFFF"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeDasharray="7 8"
                    d={TRAIL_PATH}
                  />
                  <g>
                    {/* peakTrophy → the 3D trophy is an HTML overlay outside the
                        SVG (see below), so render nothing here. TV still uses the
                        foreignObject; otherwise the static award image. */}
                    {peakTrophy ? null : tvTrophyOverlay ? (
                      <foreignObject x="434" y="104" width="160" height="160">
                        {tvTrophyOverlay}
                      </foreignObject>
                    ) : (
                      <image
                        x="443"
                        y="95"
                        width="80"
                        href={trophy}
                        style={{cursor: 'pointer'}}
                        onClick={handlePriceClick}
                      />
                    )}
                  </g>
                </g>
              </g>
              <g>
                <defs>
                  <rect id="SVGID_1_" x="0" y="116" width="930" height="488" />
                </defs>
                <clipPath id="SVGID_2_">
                  <use href="#SVGID_1_" overflow="visible" />
                </clipPath>
                {/** Yeti circle and line */}
                <g clipPath="url(#SVGID_2_)">
                  <g id="end-g-person2">
                    <line
                      id="end-line-person2"
                      fill="none"
                      stroke="#EC2786"
                      strokeWidth="3"
                      strokeMiterlimit="10"
                      x1="474"
                      y1="541"
                      x2="1583"
                      y2="541"
                    />
                    <circle fill="none" cx="474" cy="541" r="1109" />
                    <circle
                      id="end-circle-person2"
                      cx="489"
                      cy="541.5"
                      r="3"
                      fill="#FFFFFF"
                    />
                    <circle
                      id="end-circle-person2"
                      cx="474.5"
                      cy="541.5"
                      r="9"
                      fill="#EC2786"
                      stroke="#FFFFFF"
                      strokeWidth="2"
                    />
                  </g>
                  {/** Player circle and line */}
                  <g id="end-g-person1">
                    <line
                      id="end-line-person1"
                      fill="none"
                      stroke={brighterPrimaryColor}
                      strokeWidth="3"
                      strokeMiterlimit="10"
                      x1="423"
                      y1="523"
                      x2="1532"
                      y2="523"
                    />
                    <circle fill="none" cx="423" cy="523" r="1109" />
                    <circle
                      id="end-circle-person1"
                      cx="438"
                      cy="523.5"
                      r="3"
                      fill="#FFFFFF"
                    />
                    <circle
                      id="end-circle-person1"
                      cx="423.5"
                      cy="523.5"
                      r="9"
                      fill={primaryColor}
                      stroke="#FFFFFF"
                      strokeWidth="2"
                    />
                  </g>
                </g>
              </g>
              <g id="persons">
                <g>
                  {/* Motion path = the shared Vector 24 trail, so the yeti marker
                      climbs the exact route the dashes draw. */}
                  <path id="person2-line" fill="none" d={TRAIL_PATH} />
                  <path
                    display="none"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M464.43,529.53c0,0,0.63,0,0.65,0.36c0,0-0.02,0.29,0.22,0.31
                    c0.24,0.02,0.57-0.11,0.62-0.55c0.04-0.44,0.13-1.74,0.13-1.74s0.32-1.39,1.49-3.31c1.17-1.93,2.55-3.68,2.55-3.68l1.34-1.44
                    c0,0,0.72-0.45,1.24-0.55c0.52-0.1,1.75-1.55,1.75-1.55s1.1-1.72,1.79-1.89c0.69-0.17,2-0.21,2.27,0.62
                    c0.28,0.83,0.62,1.07,0.62,1.07s0.34,0.76,0.24,1.17c-0.1,0.41-0.45,0.65-0.45,0.65l-0.07,1.38l-0.62,0.76l0.21,2.24l0.55,0.48
                    c0,0,2.51,1.03,5.2,4.71c0,0,0.41,1.69-1.41,1.51l-2.72-1.03c0,0-1.55-0.45-2.44-2.2c0,0-0.55-0.34-0.69,0.07
                    c-0.14,0.41,0.1,1.03,0.1,1.03v1.69c0,0,0.89,1.79,1.17,2.27c0.28,0.48,1.51,2.13,1.58,3.68c0.07,1.55,0.17,4.23,0.17,4.23
                    s0.38,0.58,0.93,0.93c0.55,0.34,1.1,0.69,1.1,0.69l0.17,0.58h-5.57c0,0-0.41-0.34-0.45-1.41c-0.03-1.07,0.28-3.06,0.28-3.06
                    l-0.86-2.24l-0.83-1.07c0,0-0.38-0.24-0.48,0.17c-0.1,0.41,0,1.96,0,2.48c0,0.52-0.58,1.62-1.75,2.24c-1.17,0.62-1.93,0.58-1.86,1
                    c0.07,0.41,0.58,0.83,0.58,0.83l0.65,0.48l0.24,0.58c0,0-0.62,0.24-1.24,0.14c-0.62-0.1-0.89-0.31-1.38-0.38
                    c-0.48-0.07-1.38-0.31-1.38-0.31s-1.58-0.52-1.72-1.2c-0.14-0.69,0.31-0.93,0.72-1.24c0.41-0.31,1.51-1.17,1.51-1.17
                    s1.69-2.1,1.93-3.34c0.24-1.24,0.07-1.48,0.07-1.48s-0.96-0.45-1.2-1.34c-0.24-0.89-0.07-2.51-0.07-2.51s-0.41-0.55-0.86,0.17
                    c-0.45,0.72-0.24,3.03-3.17,3.1C465.3,532.44,462.77,530.65,464.43,529.53z"
                  />

                  {/* <image
                    overflow="visible"
                    width="512"
                    height="512"
                    id="person2"
                    href={person}
                    transform="matrix(0.0547 0 0 0.0547 461 514)"
                  /> */}
                </g>
                <g>
                  {/* Motion path = the shared Vector 24 trail (player marker). */}
                  <path id="person1-line" fill="none" d={TRAIL_PATH} />
                  <path
                    display="none"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M414.08,510.6c0,0,0.63,0,0.65,0.36c0,0-0.02,0.29,0.22,0.31
                    c0.24,0.02,0.57-0.11,0.62-0.55c0.04-0.44,0.13-1.74,0.13-1.74s0.32-1.39,1.49-3.31c1.17-1.93,2.55-3.68,2.55-3.68l1.34-1.45
                    c0,0,0.72-0.45,1.24-0.55c0.52-0.1,1.75-1.55,1.75-1.55s1.1-1.72,1.79-1.89c0.69-0.17,2-0.21,2.27,0.62
                    c0.28,0.83,0.62,1.07,0.62,1.07s0.34,0.76,0.24,1.17c-0.1,0.41-0.45,0.65-0.45,0.65l-0.07,1.38l-0.62,0.76l0.21,2.24l0.55,0.48
                    c0,0,2.51,1.03,5.2,4.71c0,0,0.41,1.69-1.41,1.51l-2.72-1.03c0,0-1.55-0.45-2.44-2.2c0,0-0.55-0.34-0.69,0.07
                    c-0.14,0.41,0.1,1.03,0.1,1.03v1.69c0,0,0.89,1.79,1.17,2.27c0.28,0.48,1.51,2.13,1.58,3.68c0.07,1.55,0.17,4.23,0.17,4.23
                    s0.38,0.58,0.93,0.93c0.55,0.34,1.1,0.69,1.1,0.69l0.17,0.58h-5.57c0,0-0.41-0.34-0.45-1.41c-0.03-1.07,0.28-3.06,0.28-3.06
                    l-0.86-2.24l-0.83-1.07c0,0-0.38-0.24-0.48,0.17c-0.1,0.41,0,1.96,0,2.48c0,0.52-0.58,1.62-1.75,2.24c-1.17,0.62-1.93,0.58-1.86,1
                    c0.07,0.41,0.58,0.83,0.58,0.83l0.65,0.48l0.24,0.58c0,0-0.62,0.24-1.24,0.14c-0.62-0.1-0.89-0.31-1.38-0.38
                    c-0.48-0.07-1.38-0.31-1.38-0.31s-1.58-0.52-1.72-1.2c-0.14-0.69,0.31-0.93,0.72-1.24c0.41-0.31,1.51-1.17,1.51-1.17
                    s1.69-2.1,1.93-3.34c0.24-1.24,0.07-1.48,0.07-1.48s-0.96-0.45-1.2-1.34c-0.24-0.89-0.07-2.51-0.07-2.51s-0.41-0.55-0.86,0.17
                    c-0.45,0.72-0.24,3.03-3.17,3.1C414.95,513.51,412.42,511.72,414.08,510.6z"
                  />

                  {/* <image
                    overflow="visible"
                    width="512"
                    height="512"
                    id="person1"
                    href={person}
                    transform="matrix(0.0547 0 0 0.0547 410 496)"
                  /> */}
                </g>
              </g>
              {/* Remap the ruler (authored for y135–604) onto the mountain:
                  max tick → peak (~y174), 0 tick → trail base (~y592), so the
                  scale lines up with the mountain and the markers. */}
              <g id="menu" transform="translate(0 53.7) scale(1 0.8913)">
                <g id="right-nums">
                  <rect
                    x="906"
                    y="129.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="none"
                    width="60"
                    height="12.01"
                  />
                  <text
                    transform="matrix(1 0 0 1 906 139.5186)"
                    fontFamily="'Roboto'"
                    textAnchor="end"
                    fontSize="14px"
                    fontWeight="700"
                    fill={darkMode ? "#FFF" : "#000"}
                  >
                    {axisMax}
                  </text>
                  <rect
                    x="906"
                    y="188.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="none"
                    width="60"
                    height="12.01"
                  />
                  <text
                    transform="matrix(1 0 0 1 906 199.5186)"
                    fontFamily="'Roboto'"
                    textAnchor="end"
                    fontSize="14px"
                    fontWeight="500"
                    fill={darkMode ? "#FFF" : "#000"}
                  >
                    {(7 / 8) * axisMax}
                  </text>
                  <rect
                    x="906"
                    y="248.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="none"
                    width="60"
                    height="12.01"
                  />
                  <text
                    transform="matrix(1 0 0 1 906 257.5186)"
                    fontFamily="'Roboto'"
                    textAnchor="end"
                    fontSize="14px"
                    fontWeight="700"
                    fill={darkMode ? "#FFF" : "#000"}
                  >
                    {(6 / 8) * axisMax}
                  </text>
                  <rect
                    x="906"
                    y="306.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="none"
                    width="60"
                    height="12.01"
                  />
                  <text
                    transform="matrix(1 0 0 1 906 317.5186)"
                    fontFamily="'Roboto'"
                    textAnchor="end"
                    fontSize="14px"
                    fontWeight="700"
                    fill={darkMode ? "#FFF" : "#000"}
                  >
                    {(5 / 8) * axisMax}
                  </text>
                  <rect
                    x="906"
                    y="364.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="none"
                    width="60"
                    height="12.01"
                  />
                  <text
                    transform="matrix(1 0 0 1 906 375.5186)"
                    fontFamily="'Roboto'"
                    textAnchor="end"
                    fontSize="14px"
                    fontWeight="700"
                    fill={darkMode ? "#FFF" : "#000"}
                  >
                    {(4 / 8) * axisMax}
                  </text>
                  <rect
                    x="906"
                    y="425.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="none"
                    width="60"
                    height="12.01"
                  />
                  <text
                    transform="matrix(1 0 0 1 906 434.5186)"
                    fontFamily="'Roboto'"
                    textAnchor="end"
                    fontSize="14px"
                    fontWeight="700"
                    fill={darkMode ? "#FFF" : "#000"}
                  >
                    {(3 / 8) * axisMax}
                  </text>
                  <rect
                    x="906"
                    y="484.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="none"
                    width="60"
                    height="12.01"
                  />
                  <text
                    transform="matrix(1 0 0 1 906 492.5186)"
                    fontFamily="'Roboto'"
                    textAnchor="end"
                    fontSize="14px"
                    fontWeight="700"
                    fill={darkMode ? "#FFF" : "#000"}
                  >
                    {(2 / 8) * axisMax}
                  </text>
                  <rect
                    x="906"
                    y="541.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="none"
                    width="60"
                    height="12.01"
                  />
                  <text
                    transform="matrix(1 0 0 1 906 552.5186)"
                    fontFamily="'Roboto'"
                    textAnchor="end"
                    fontSize="14px"
                    fontWeight="700"
                    fill={darkMode ? "#FFF" : "#000"}
                  >
                    {(1 / 8) * axisMax}
                  </text>
                  <rect
                    x="906"
                    y="599.99"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="none"
                    width="60"
                    height="12.01"
                  />
                  <text
                    transform="matrix(1 0 0 1 906 610.5186)"
                    fontFamily="'Roboto'"
                    textAnchor="end"
                    fontSize="14px"
                    fontWeight="700"
                    fill={darkMode ? "#FFF" : "#000"}
                  >
                    {0}
                  </text>
                </g>
                <g>
                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="909.96"
                    y1="604.3"
                    x2="929.96"
                    y2="604.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="909.96"
                    y1="545.55"
                    x2="929.96"
                    y2="545.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="598.43"
                    x2="929.96"
                    y2="598.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="592.55"
                    x2="929.96"
                    y2="592.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="586.68"
                    x2="929.96"
                    y2="586.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="580.8"
                    x2="929.96"
                    y2="580.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="574.93"
                    x2="929.96"
                    y2="574.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="569.05"
                    x2="929.96"
                    y2="569.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="563.18"
                    x2="929.96"
                    y2="563.18"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="557.3"
                    x2="929.96"
                    y2="557.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="551.43"
                    x2="929.96"
                    y2="551.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="909.96"
                    y1="486.8"
                    x2="929.96"
                    y2="486.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="539.68"
                    x2="929.96"
                    y2="539.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="533.8"
                    x2="929.96"
                    y2="533.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="527.93"
                    x2="929.96"
                    y2="527.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="522.05"
                    x2="929.96"
                    y2="522.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="516.18"
                    x2="929.96"
                    y2="516.18"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="510.3"
                    x2="929.96"
                    y2="510.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="504.43"
                    x2="929.96"
                    y2="504.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="498.55"
                    x2="929.96"
                    y2="498.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="492.68"
                    x2="929.96"
                    y2="492.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="909.96"
                    y1="428.05"
                    x2="929.96"
                    y2="428.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="480.93"
                    x2="929.96"
                    y2="480.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="475.05"
                    x2="929.96"
                    y2="475.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="469.18"
                    x2="929.96"
                    y2="469.18"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="463.3"
                    x2="929.96"
                    y2="463.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="457.43"
                    x2="929.96"
                    y2="457.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="451.55"
                    x2="929.96"
                    y2="451.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="445.68"
                    x2="929.96"
                    y2="445.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="439.8"
                    x2="929.96"
                    y2="439.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="433.93"
                    x2="929.96"
                    y2="433.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="909.96"
                    y1="369.3"
                    x2="929.96"
                    y2="369.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="422.18"
                    x2="929.96"
                    y2="422.18"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="416.3"
                    x2="929.96"
                    y2="416.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="410.43"
                    x2="929.96"
                    y2="410.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="404.55"
                    x2="929.96"
                    y2="404.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="398.68"
                    x2="929.96"
                    y2="398.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="392.8"
                    x2="929.96"
                    y2="392.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="386.93"
                    x2="929.96"
                    y2="386.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="381.05"
                    x2="929.96"
                    y2="381.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="375.18"
                    x2="929.96"
                    y2="375.18"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="909.96"
                    y1="310.55"
                    x2="929.96"
                    y2="310.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="363.43"
                    x2="929.96"
                    y2="363.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="357.55"
                    x2="929.96"
                    y2="357.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="351.68"
                    x2="929.96"
                    y2="351.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="345.8"
                    x2="929.96"
                    y2="345.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="339.93"
                    x2="929.96"
                    y2="339.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="334.05"
                    x2="929.96"
                    y2="334.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="328.18"
                    x2="929.96"
                    y2="328.18"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="322.3"
                    x2="929.96"
                    y2="322.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="316.43"
                    x2="929.96"
                    y2="316.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="909.96"
                    y1="251.8"
                    x2="929.96"
                    y2="251.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="304.68"
                    x2="929.96"
                    y2="304.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="298.8"
                    x2="929.96"
                    y2="298.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="292.93"
                    x2="929.96"
                    y2="292.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="287.05"
                    x2="929.96"
                    y2="287.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="281.18"
                    x2="929.96"
                    y2="281.18"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="275.3"
                    x2="929.96"
                    y2="275.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="269.43"
                    x2="929.96"
                    y2="269.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="263.55"
                    x2="929.96"
                    y2="263.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="257.68"
                    x2="929.96"
                    y2="257.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="909.96"
                    y1="193.05"
                    x2="929.96"
                    y2="193.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="245.93"
                    x2="929.96"
                    y2="245.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="240.05"
                    x2="929.96"
                    y2="240.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="234.18"
                    x2="929.96"
                    y2="234.18"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="228.3"
                    x2="929.96"
                    y2="228.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="222.43"
                    x2="929.96"
                    y2="222.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="216.55"
                    x2="929.96"
                    y2="216.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="210.68"
                    x2="929.96"
                    y2="210.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="204.8"
                    x2="929.96"
                    y2="204.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="198.93"
                    x2="929.96"
                    y2="198.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="909.96"
                    y1="134.3"
                    x2="929.96"
                    y2="134.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="187.18"
                    x2="929.96"
                    y2="187.18"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="181.3"
                    x2="929.96"
                    y2="181.3"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="175.43"
                    x2="929.96"
                    y2="175.43"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="169.55"
                    x2="929.96"
                    y2="169.55"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="163.68"
                    x2="929.96"
                    y2="163.68"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="157.8"
                    x2="929.96"
                    y2="157.8"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="151.93"
                    x2="929.96"
                    y2="151.93"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="146.05"
                    x2="929.96"
                    y2="146.05"
                  />

                  <line
                    fill="none"
                    stroke={primaryColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    x1="917.96"
                    y1="140.18"
                    x2="929.96"
                    y2="140.18"
                  />
                </g>
                <g>
                  <image x="900" y="95" width="45" href={menuTrophy} style={{filter: (theme) => `brightness(0) saturate(100%) ${theme.palette.tertiary.dark}`}} />
                </g>
              </g>
            </svg>
            {peakTrophy && <PeakTrophyOverlay svgRef={svgRef} vbSize={96} baseFactor={1.02} />}
          </SoftBox>

          {/** Player + yeti score cards — stacked top-left, each border tinted
              with its climber's colour (player = brand blue, yeti = pink) so you
              can read which card is which at a glance. */}
          <SoftBox
            sx={{
              position: "absolute",
              // Clear the 56px title strip (+ margin) so the cards sit below it,
              // not on top of "King of the Mountain".
              top: { mini: "100px", xs: "80px" },
              left: { mini: "7%", md: "6%" },
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              pointerEvents: "none",
            }}
          >
            <SoftBox
              shadow="sm"
              sx={{
                order: playerLeads ? 0 : 1,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: darkMode ? "rgba(13,13,13,0.85)" : "rgba(255,255,255,0.94)",
                backdropFilter: "blur(6px)",
                border: `1px solid ${primaryColor}`,
                borderRadius: "12px",
                padding: "6px 10px",
              }}
            >
              <SoftProfile size="sm" src={playerLogo} name={playerName} fullCover />
              <SoftBox lineHeight={1}>
                <SoftTypography sx={{ fontFamily: "DM Sans", fontSize: { mini: "15px", md: "18px" }, fontWeight: 700, lineHeight: 1.15, color: darkMode ? "#fff" : "#0F172A" }}>
                  <span ref={playerPtsRef}>
                    {Number.isNaN(playerScore) || !Number.isFinite(playerScore) ? 0 : Math.round(playerScore)}
                  </span>
                </SoftTypography>
                <SoftTypography sx={{ fontFamily: "DM Sans", fontSize: "12px", color: darkMode ? "#B9C0C9" : "#667085" }}>
                  Points
                </SoftTypography>
              </SoftBox>
            </SoftBox>

            <SoftBox
              shadow="sm"
              sx={{
                order: playerLeads ? 1 : 0,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: darkMode ? "rgba(13,13,13,0.85)" : "rgba(255,255,255,0.94)",
                backdropFilter: "blur(6px)",
                border: "1px solid #EC2786",
                borderRadius: "12px",
                padding: "6px 10px",
              }}
            >
              <SoftProfile size="sm" src={YETI_PROFILE.image} name={YETI_PROFILE.firstName} />
              <SoftBox lineHeight={1}>
                <SoftTypography sx={{ fontFamily: "DM Sans", fontSize: { mini: "15px", md: "18px" }, fontWeight: 700, lineHeight: 1.15, color: darkMode ? "#fff" : "#0F172A" }}>
                  <span ref={yetiPtsRef}>{Math.round(yetiScore)}</span>
                </SoftTypography>
                <SoftTypography sx={{ fontFamily: "DM Sans", fontSize: "12px", color: darkMode ? "#B9C0C9" : "#667085" }}>
                  Points
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      ) : null}
    </>
  );
};

export default KingOfTheMountain;
